import type { ComponentType } from "react"

import { BrandFacet } from "@/components/marketplace/listing/brand-facet"
import { ColorFacet } from "@/components/marketplace/listing/color-facet"
import { PillFacet } from "@/components/marketplace/listing/pill-facet"
import type { FacetValue } from "@/lib/types/search"

export interface FacetBodyProps {
  options: FacetValue[]
  selected: string[]
  onToggle: (value: string) => void
}

const FACET_BODIES: Partial<Record<string, ComponentType<FacetBodyProps>>> = { brand: BrandFacet, color: ColorFacet }

export const facetBodyFor = (key: string): ComponentType<FacetBodyProps> => FACET_BODIES[key] ?? PillFacet
